module.exports = __webpack_public_path__ + "img/customer2.9af160cd.png";